import { render, staticRenderFns } from "./IDMLLayersTree.vue?vue&type=template&id=63ea694e&scoped=true"
import script from "./IDMLLayersTree.vue?vue&type=script&lang=js"
export * from "./IDMLLayersTree.vue?vue&type=script&lang=js"
import style0 from "./IDMLLayersTree.vue?vue&type=style&index=0&id=63ea694e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ea694e",
  null
  
)

export default component.exports